import type { BrandingOutput } from '@garage/shared';
import { garageMonogram } from './components/BrandMark.js';
import { readableOn } from './theme.js';

/**
 * Favicon du garage actif (vague 5, A3) : son icône carrée, sinon ses initiales sur sa couleur de
 * marque (SVG construit à l'exécution depuis la marque renvoyée par l'API, aucune couleur en dur).
 * Sans garage (connexion, console, portail) : pictogramme de la plateforme (`public/favicon.svg`, pack « Rouge Pulse »).
 */
const GENERIC = '/favicon.svg';

function escapeXml(s: string): string {
  return s.replace(/[<>&'"]/g, (c) => `&#${c.charCodeAt(0)};`);
}

export function faviconHref(brand: Pick<BrandingOutput, 'displayName' | 'primaryColor' | 'iconUrl'> | null): string {
  if (!brand) return GENERIC;
  if (brand.iconUrl) return brand.iconUrl;
  const mono = garageMonogram(brand.displayName) || '·';
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">` +
    `<rect width="64" height="64" rx="14" fill="${escapeXml(brand.primaryColor)}"/>` +
    `<text x="32" y="42" text-anchor="middle" font-family="system-ui,sans-serif" font-size="28" font-weight="700" fill="${readableOn(brand.primaryColor)}">${escapeXml(mono)}</text>` +
    `</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

export function applyFavicon(brand: Pick<BrandingOutput, 'displayName' | 'primaryColor' | 'iconUrl'> | null, doc: Document = document): void {
  let link = doc.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = doc.createElement('link');
    link.rel = 'icon';
    doc.head.appendChild(link);
  }
  link.href = faviconHref(brand);
}
